import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Divider } from '@mui/material';

// 내부 컴포넌트: 헤더 스타일 (제공해주신 HeaderItem 스타일 적용)
const HeaderItem = ({ xs, label }) => (
  <Grid item xs={xs} align="center">
    <Typography sx={{ fontWeight: 'bold', color: '#333', fontSize: '0.9rem', lineHeight: '32px' }}>
      {label}
    </Typography>
  </Grid>
);

// 내부 컴포넌트: 데이터 스타일 (제공해주신 DataItem 스타일 적용)
const DataItem = ({ xs, value, color = '#000' }) => (
  <Grid item xs={xs} align="center">
    <Typography sx={{ 
      fontSize: '0.95rem', 
      color: color, 
      lineHeight: '32px', 
      whiteSpace: 'nowrap', 
      overflow: 'hidden', 
      textOverflow: 'ellipsis' 
    }}>
      {value || '-'}
    </Typography>
  </Grid>
);

const OrderBookSummary = ({ orderInfo, approvalList }) => {
  const [finalApproveDate, setFinalApproveDate] = useState('');

  useEffect(() => {
    if (approvalList && approvalList.length > 0) {
      const lastApproval = approvalList[approvalList.length - 1];
      setFinalApproveDate(lastApproval?.docuDt || '');
    }
  }, [approvalList]);

  const getStatus = (yn) => {
    if (yn === 'S') return { text: '진행중', color: '#1976d2' };
    if (yn === 'Y') return { text: '완료', color: '#2e7d32' };
    if (yn === 'N') return { text: '미결재', color: '#d32f2f' };
    return { text: '-', color: '#666' };
  };

  const status = getStatus(orderInfo?.ordYn);

  return (
    <Box sx={{ width: '100%' }}>
      {/* 헤더 영역: 높이 32px 고정 및 배경색 적용 */}
      <Grid 
        container 
        sx={{ 
          height: '32px', 
          bgcolor: '#f1f3f5', 
          alignItems: 'center',
          borderTop: '1px solid #dee2e6'
        }}
      >
        <HeaderItem xs={2.5} label="문서번호" />
        <HeaderItem xs={1.5} label="문서명" />
        <HeaderItem xs={2} label="작성일자" />
        <HeaderItem xs={1.5} label="작성자" />
        <HeaderItem xs={2} label="결재상태" />
        <HeaderItem xs={2.5} label="최종승인일자" />
      </Grid>

      {/* 데이터 영역: 높이 32px 고정 */}
      <Grid 
        container 
        sx={{ 
          height: '32px', 
          alignItems: 'center', 
          bgcolor: '#fff' 
        }}
      >
        <DataItem xs={2.5} value={orderInfo?.roNo} />
        <DataItem xs={1.5} value="수주품의서" />
        <DataItem xs={2} value={orderInfo?.crtDt} />
        <DataItem xs={1.5} value={orderInfo?.crtNm} />
        <DataItem xs={2} value={status.text} color={status.color} />
        <DataItem xs={2.5} value={finalApproveDate} />
      </Grid>
      <Divider />
    </Box>
  );
};

export default OrderBookSummary;
